import store from '@/store'
import axios from 'axios'
import securityApi from '@/api/security'
import router from '@/router'

export default {
    async login(requestData, otpVerified) {
         // No try/catch needed here since we want to hit Login.vue's catch
        let response = null
        if (otpVerified) {
            response = await securityApi.login2(requestData)
        } else {
            response = await securityApi.login(requestData)
        }

        // This block only runs if status is 2xx
        if (response && response.status == 200) {
            store.commit('setPassword', requestData.password)
            this.saveUserState(response, false)
        }
        
        return response;
    }, 
    async switchAccount(requestData) {
        try {
            const response = await securityApi.switchAccount(requestData)
            if (response && response.status == 200) {
                this.saveUserState(response, true)
            }
        }catch(error){
            throw error
        }
    },  
    saveUserState(response, isSwitchAccount){
        try {
            axios.defaults.headers["Authorization"] = `Bearer ${response.data.token}`
            axios.defaults.headers["session_id"] = response.data.sessionId

            let user = response.data.user

            //token details   
            localStorage.token = response.data.token            
            localStorage.refreshToken = response.data.refreshToken
            localStorage.sessionId = response.data.sessionId

            store.commit('setOnBoarded', user.onBoarded)
            store.commit('setChangedPassword', user.changedPassword)
            store.commit('setIsLinkedAccount', user.isLinkedAccount)

            //user details
            store.commit('setDashboardTheme', response.data.dashboardTheme)
            store.commit('setUserId', user.userId) 
            store.commit('setParentUserId', user.parentUserId)
            store.commit('setUserName', user.firstName + ' ' + user.lastName) 
            store.commit('setName', user.firstName + ' ' + user.lastName) 
            store.commit('setFirstName', user.firstName)
            store.commit('setLastName', user.lastName)        
            store.commit('setEmail', user.email) 
            store.commit('setRoleKey', user.rlky)
            store.commit('setTwoFA', user.twoFA)
            store.commit('setAppNotification', user.appNotification)
            store.commit('setEmailNotification', user.emailNotification)
            store.commit('setTwoFAVerified', false)
            store.commit('setNewDevice', user.newDevice)

            if (!isSwitchAccount) {
                store.commit('setIsDeviceLoginCredentialExists', response.data.isDeviceLoginCredentialExists)
            }

            //personalized settings
            store.commit('setTheme', user.theme)
            store.commit('setColor', user.color)
            store.commit('setLeftNavMini', user.leftNavMini)
            store.commit('setLeftNavToggle', user.leftNavToggle)
            store.commit('setRightNavMini', user.rightNavMini)
            store.commit('setRightNavToggle', user.rightNavToggle)
            
            store.commit('setToken', user.token)      

            //team details           
            store.commit('setTeamId', user.teamId)   
            store.commit('setTeamName', user.team) 
            store.commit('setTeamLogo', user.teamLogoFileName)

            //company details
            store.commit('setCompanyId', user.companyId) //using encrypted companyId
            store.commit('setCompanyName', user.company)
            store.commit('setCompanyAccount', response.data.account)
            store.commit('setCompanyLogo', user.companyLogoFileName)

            store.commit('setTeamCount', user.teamCount)
            store.commit('setUserCount', user.userCount)
            store.commit('setAccountName', user.accountName)
            store.commit('setAccountKey', user.accountKey)
        }catch(error){
            console.log('saveUserState: ', error)
        }
    },
    loggedIn () {
        return !!localStorage.token
    },
    requiresChangePassword() {
        return !store.state.changedPassword
    },
    onBoarded() {
        return store.state.onBoarded
    },
    deleteToken() {
        store.commit('setToken', null)
        delete localStorage.token
        delete localStorage.refreshToken
        axios.defaults.headers["Authorization"] = ''
        axios.defaults.headers["session_id"] = ''
    },
    clearLoginDetails() {
        store.commit('setPassword', '')
    },
    clearAuth() {
        axios.defaults.headers["Authorization"] = ''
        axios.defaults.headers["session_id"] = ''

        delete localStorage.token
        delete localStorage.refreshToken
        delete localStorage.sessionId
        
        store.commit('setPassword', '')
        store.commit('setOnBoarded', '')
        store.commit('setChangedPassword', '')
        store.commit('setIsLinkedAccount', false)

        //user details        
        store.commit('setDashboardTheme', null)
        store.commit('setParentUserId', '')
        store.commit('setUserName', '') 
        store.commit('setName', '')       
        store.commit('setEmail', '')         
        store.commit('setRoleKey', '')
        store.commit('setTwoFA', null)
        store.commit('setTwoFAVerified', null)
        store.commit('setNewDevice', null)

        //personalized settings
        store.commit('setTheme', '')
        store.commit('setColor', '')
        store.commit('setLeftNavMini', '')
        store.commit('setLeftNavToggle', '')
        store.commit('setRightNavMini', '')
        store.commit('setRightNavToggle', '')
        store.commit('setToken', '')         
        
        //team details           
        store.commit('setTeamId', '')
        store.commit('setTeamName', '') 
        store.commit('setTeamLogo', '')
        //company details
        store.commit('setCompanyId', '')
        store.commit('setCompanyName', '')
        store.commit('setCompanyLogo', '')
        store.commit('setCompanyAccount', '')

        store.commit('setGeoAddress', '')
        store.commit('setGeoAddressAsOf', '')
        
        store.commit('setTeamCount', null)
        store.commit('setUserCount', null)
        store.commit('setAccountName', null)
        store.commit('setAccountKey', null)
        store.commit('removeNotifCount', null)
        
        // DON'T CLEAR
        // setAvatar

        // DON'T CLEAR THESE TO HAVE DEFAULT TEAM EVEN WITHOUT GOING TO MYTEAMS
        // setSelectedTeamName
        // setSelectedTeamId
        // setSelectedTeamRole
        // setSelectedTeamPermissions
        
        // DON'T CLEAR the following, used in personalized public pages
        // setUserAppsList
        // setUserId
        // setIsDeviceLoginCredentialExists
        // setFirstName
        // setLastName        
    },
    async logout(data) {
        if (data) {
            try {
                await securityApi.logout(data)
            }catch(error){
                throw error
            }finally{
                this.clearAuth()
                if (data.logoutCode == 'Change Password') {
                    router.push(`/login`) 
                }else{
                    router.push(`/home?action=${data.logoutCode}`) 
                }
            }
        }
    }
}